import React, { Fragment, useCallback } from "react";
import { emptyStringIfNull, withFormWrapper, } from "./withFormWrapper";
import { observer } from "mobx-react-lite";
import { FormControl, FormGroup } from "react-bootstrap";
import { useFormContext } from "./Form";
import { HTMLEditor } from "./HTMLEditor";
import { StaticInputValue } from "./StaticInput";
import { SafeHTMLDisplay } from ".";
import { Button as BSButton, Glyphicon } from "react-bootstrap";
import { useTranslation } from "./hooks/useTranslation";
import { WYSIWYGEditor } from "./WYSIWYGEditor";
import { Button } from "./Button";
import { PlainTextEditor } from "./WYSIWYGEditor/PlainTextEditor";
export const RawHTMLInput = observer(({ name, onChange, onBlur, onInit, disabled, staticFormatter = (value) => React.createElement(SafeHTMLDisplay, { html: value }), label, dataId, dataLabel, dataTestId, customControls = [], fonts = {}, sizes = {}, isPlaintext = false, inputRef, useJodit = false, width, height, allowTabNavigation, useNativeTooltip, toolbarAdaptive, showPlaceholder, }) => {
    const t = useTranslation();
    const { isStatic, values, formDisabled } = useFormContext();
    const [rawHTMLMode, setRawHTMLMode] = React.useState(false);
    const value = values.get(name) || "";
    const toggleRawHTMLMode = () => {
        setRawHTMLMode(!rawHTMLMode);
    };
    const sourceButton = (React.createElement(BSButton, { onClick: toggleRawHTMLMode, active: rawHTMLMode, title: rawHTMLMode ? "Rich Text" : "HTML", key: "sourceButton", "data-testid": dataTestId ? `sourceButton-${dataTestId}` : undefined },
        React.createElement(Glyphicon, { glyph: "pro-code" })));
    const toolbarButtons = customControls.map((toolbarButtonProp) => {
        return (React.createElement(Fragment, { key: toolbarButtonProp.name },
            React.createElement(Button, { onClick: toolbarButtonProp.onClick, label: toolbarButtonProp.label, disabled: toolbarButtonProp.disabled })));
    });
    const controls = [sourceButton, ...toolbarButtons];
    const handleChange = useCallback((updatedHtml) => {
        if (onChange) {
            onChange(updatedHtml, values.get(name));
        }
        values.set(name, updatedHtml);
    }, [onChange, values, name]);
    const handleBlur = useCallback((updatedHtml) => {
        if (onBlur) {
            onBlur(updatedHtml, values.get(name));
        }
        values.set(name, updatedHtml);
    }, [onBlur, values, name]);
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, type: "html", dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    return (React.createElement(FormGroup, { "data-id": dataId && `static-${dataId}`, "data-testid": dataTestId && `static-${dataTestId}`, "data-label": dataLabel, bsClass: "html-input" },
        useJodit && (React.createElement(React.Fragment, null,
            isPlaintext && (React.createElement(PlainTextEditor, { customControls: customControls, label: "Body", name: "body" })),
            !isPlaintext && (React.createElement(WYSIWYGEditor, { html: value, onChange: handleChange, onBlur: handleBlur, onInit: onInit, customControls: customControls, fonts: fonts, sizes: sizes, "data-testid": dataTestId ? `htmlEditor-${dataTestId}` : undefined, disabled: disabled || formDisabled, width: width, height: height, allowTabNavigation: allowTabNavigation, useNativeTooltip: useNativeTooltip, toolbarAdaptive: toolbarAdaptive, showPlaceholder: showPlaceholder })))),
        !useJodit && (React.createElement(React.Fragment, null,
            React.createElement(HTMLEditor, { html: value, onChange: handleChange, disabled: disabled || formDisabled, inputRef: inputRef, customControls: rawHTMLMode ? [sourceButton] : controls, hideEditor: rawHTMLMode, "data-testid": dataTestId ? `htmlEditor-${dataTestId}` : undefined }),
            rawHTMLMode && (React.createElement(FormControl, { name: name, "data-label": t("Raw HTML Input"), value: emptyStringIfNull(value), onChange: (e) => handleChange(e.target.value), componentClass: "textarea", rows: 8, disabled: disabled || formDisabled, "data-testid": dataTestId ? `rawHTML-${dataTestId}` : undefined }))))));
});
export const HTMLInput = withFormWrapper({ WrappedComponent: RawHTMLInput });
